// The Bible Standard mark with the Fellowship wordmark (BibleStandardSite brand/README.md). Both marks
// are alpha masks painted by the page with --rubric-ink (crimson #8c1d20 on paper, a rose at night, as
// the site paints them), so one file is right in both themes and no source colour is ever shipped.
//   - the compact mark (head, halo, staff, banner; heavy strokes) wherever the mark is small;
//   - the full engraving only where it's shown large: the quiet watermark and the 404 plate.
import type { CSSProperties } from "react";
import s from "./Logo.module.css";

type LogoProps = {
  /** The mark's size in rem. Default 1.75. */
  size?: number;
  /** "row": mark beside the wordmark (bars). "stack": mark over it (a front door). */
  layout?: "row" | "stack";
  /** The wordmark's size in rem; the mark scales with it by default. */
  wordSize?: number;
  /** Leave out the wordmark (an icon-only place; the caller names it). */
  markOnly?: boolean;
  className?: string;
};

export function Logo({ size = 1.75, layout = "row", wordSize, markOnly = false, className }: LogoProps) {
  const style = { "--logo-mark": `${size}rem`, ...(wordSize ? { "--logo-word": `${wordSize}rem` } : {}) } as CSSProperties;
  return (
    <span className={[s.lockup, layout === "stack" ? s.stack : "", className ?? ""].filter(Boolean).join(" ")} style={style}>
      <span className={s.mark} aria-hidden="true" />
      {!markOnly && <span className={s.word}>Fellowship</span>}
    </span>
  );
}

/** The full engraving, large and quiet behind a page: decorative only. */
export function Watermark({ className }: { className?: string }) {
  return <span className={[s.watermark, className ?? ""].filter(Boolean).join(" ")} aria-hidden="true" />;
}

/** The full engraving as a plate, for the not-found page. */
export function Plate({ size = 10 }: { size?: number }) {
  return <span className={s.plate} style={{ "--plate": `${size}rem` } as CSSProperties} aria-hidden="true" />;
}
